import { message } from 'antd';
import { ArgsProps } from 'antd/es/message';
import { Toast } from 'antd-mobile';
import { createContext, useContext, useEffect, useState } from 'react';

import { useDevice } from '@/v1/main/views/Provider';

interface MessageContextProps {
    setMessageOption: (value: MessageOption) => void;
}

interface MessageProviderProps {
    children: React.ReactNode;
}

const MessageContext = createContext<MessageContextProps | undefined>(
    undefined
);

export enum MessageType {
    ERROR = 'error',
    INFO = 'info',
    SUCCESS = 'success',
    WARNING = 'warning',
    LOADING = 'loading',
}
export type MessageOption = ArgsProps;
export const MessageProvider = ({ children }: MessageProviderProps) => {
    const { isMobileMode } = useDevice();

    const [messageApi, contextHolder] = message.useMessage();
    const [option, setMessageOption] = useState<MessageOption>();

    useEffect(() => {
        if (option) {
            if (isMobileMode) {
                option.duration = (option.duration || 3) * 1000;
                Toast.show(option);
            } else {
                messageApi.open(option);
            }
        }
    }, [option]);

    return (
        <MessageContext.Provider value={{ setMessageOption }}>
            {contextHolder}
            {children}
        </MessageContext.Provider>
    );
};

export const useMessage = () => {
    const context = useContext(MessageContext);
    if (context === undefined) {
        throw new Error('useMessage must be used within a MessageProvider');
    }
    return context;
};
